import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { Package } from 'ZalamoLibrary/src/lib/ui/products/shopping-cart-back/actions/standalone';
import { translationProvider } from '@ui/nls/translations/translate.directive';

@Component({
    selector: 'lib-message-about-free-package',
    templateUrl: './message-about-free-package.component.html',
    styleUrls: ['./message-about-free-package.component.scss'],
    providers: [translationProvider('productFront')],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MessageAboutFreePackageComponent implements OnInit {
  addPackage = new Subject<boolean>();
  viewDetail = new Subject<boolean>();
  packageInShop: Package;

  constructor() {}

  ngOnInit(): void {}
}
